/* assets/one-cols-banner-init.js */
(function(){
  // Registra el módulo para secciones con data-module="banner"
  window.__SectionRegistry['banner'] = function(wrapper){
    const { gsap, ScrollTrigger } = window;
    if (!(gsap && ScrollTrigger)) {
      console.warn('[banner] GSAP/ScrollTrigger no disponibles (aún).');
      return; // sin cleanup
    }
    gsap.registerPlugin(ScrollTrigger);

    const DEBUG = !!localStorage.getItem('GSAP_DEBUG');
    if (DEBUG && !document.getElementById('gsap-markers-zfix')) {
      const s = document.createElement('style');
      s.id = 'gsap-markers-zfix';
      s.textContent = `
        .gsap-marker-start,.gsap-marker-end,
        .gsap-marker-scroller-start,.gsap-marker-scroller-end { z-index:2147483647 !important; }
      `;
      document.head.appendChild(s);
    }

    const root = wrapper.querySelector('[data-banner-root]') || wrapper;
    const bgImg = root.querySelector('.banner__bg');
    const col   = root.querySelector('.column__1');

    // Elementos de texto para stagger (ajusta selectores si prefieres)
    const items = root.querySelectorAll(
      '.column__1 .prefix, .column__1 .title, .column__1 .richtext, .column__1 .btn'
    );

    const ctx = gsap.context(() => {
      // Usa el scroller del bridge Lenis<->ScrollTrigger
      ScrollTrigger.defaults({ scroller: document.documentElement });

      // 1) Animación de BG (tu snippet)
      if (bgImg && col) {
        gsap.fromTo(
          bgImg,
          { scale: 1.2, opacity: 1 },
          {
            scale: 1,
            opacity: 1,
            ease: 'power3.out',
            overwrite: false,
            scrollTrigger: {
              trigger: root,
              start: 'top bottom',
              end: 'bottom top',
              scrub: true,
              invalidateOnRefresh: true,
            }
          }
        );

        // refrescar cuando cargue la imagen (por si llega tarde)
        if (!bgImg.complete) {
          bgImg.addEventListener('load', () => {
            requestAnimationFrame(() => ScrollTrigger.refresh());
          }, { once: true });
        }
      }

      // 2) Stagger básico del contenido (opcional)
      if (items && items.length && col) {
        gsap.from(items, {
          opacity: 0,
          y: 30,
          ease: 'power3.out',
          stagger: 0.12,
          scrollTrigger: {
            trigger: col,
            start: 'top 85%',
            end: 'bottom 75%',
            scrub: true,
          }
        });
      }

      // Pulso de refresh tras montar
      requestAnimationFrame(() => ScrollTrigger.refresh());
    }, root);

    // Cleanup para cuando el editor desmonte la sección
    return () => { try { ctx.revert(); } catch(_){} };
  };

  // Libera cola si el boot ya estaba cargado
  window.__flushSectionQueue && window.__flushSectionQueue('banner');
})();